import {
  AccountSetupSteps,
  ConsultFirstPatientSteps,
  DoctorExpertiseSteps,
  FirstTeleconsultationSteps,
  MainSteps,
  OnlineAppointmentsSteps,
  VideoConfEquipmentSteps,
  WaitingRoomSteps,
} from './enum'
import { StaffType } from './type'

export const accountSetupStepsFunctionMapping: Record<AccountSetupSteps, { redirect?: () => void; showUser?: () => void }> = {
  [AccountSetupSteps.VALIDATE_EMAIL]: {
    redirect: () => {
      return 'account-verification?step=confirm-email'
    },
  },
  [AccountSetupSteps.VALIDATE_PHONE]: {
    redirect: () => {
      return 'account-verification?step=confirm-phone-number'
    },
  },
  [AccountSetupSteps.SETUP_STRIPE]: {
    redirect: () => {
      return 'account-verification?step=configure-stripe'
    },
  },
  [AccountSetupSteps.SETUP_TWO_FACTOR_AUTH]: {},
  [AccountSetupSteps.VALIDATE_RPPS_NUMBER]: {
    redirect: () => {
      return 'account-verification?step=configure-cps-card'
    },
  },
}

export const consultFirstPatientStepsFunctionMapping: Record<ConsultFirstPatientSteps, { redirect?: () => void; showUser?: () => void }> = {
  [ConsultFirstPatientSteps.CREATE_FIRST_PATIENT]: {
    redirect: () => {
      return 'patients/create'
    },
    showUser: () => {
      return 'patients/create?intro=true'
    }
  },
  [ConsultFirstPatientSteps.PERFORM_LOCAL_CONSULTATION]: {
    redirect: () => {
      return 'consultations/create'
    },
    showUser: () => {
      return 'consultations/create?intro=true'
    },
  },
}

export const firstTeleconsultationStepsFunctionMapping: Record<FirstTeleconsultationSteps, { redirect?: () => void; showUser?: () => void }> = {
  [FirstTeleconsultationSteps.INVITE_DOCTOR]: {
    redirect: () => {
      return 'staffs'
    },
  },
  [FirstTeleconsultationSteps.SCHEDULE_TELECONSULTATION]: {
    redirect: () => {
      return 'consultations/create'
    },
    showUser: () => {
      return 'consultations/create?intro=true'
    },
  },
  [FirstTeleconsultationSteps.PERFORM_TELECONSULTATION]: {
    redirect: () => {
      return 'consultations'
    },
    showUser: () => {
      return 'consultations?intro=true'
    },
  },
}

export const doctorExpertiseStepsFunctionMapping: Record<DoctorExpertiseSteps, { redirect?: () => void; showUser?: () => void }> = {
  [DoctorExpertiseSteps.PERFORM_EXAM]: {
    redirect: () => {
      return 'consultations/create'
    },
    showUser: () => {
        return 'consultations/create?intro=true'
      },
  },
  [DoctorExpertiseSteps.REQUEST_EXPERTISE]: {
    redirect: () => {
      return 'expertises/create'
    },
    showUser: () => {
      return 'expertises/create?intro=true'
    }
  },
  [DoctorExpertiseSteps.SEND_EXPERTISE_OMNIDOC]: {
    redirect: () => {
      return 'expertises/create'
    },
    showUser: () => {
      return 'expertises/create?intro=true'
    }
  },
}

export const onlineAppointmentsStepsFunctionMapping: Record<OnlineAppointmentsSteps, { redirect?: () => void; showUser?: () => void }> = {
  [OnlineAppointmentsSteps.CREATE_APPOINTMENT_LINK]: {
    redirect: () => {
      return 'meeting-links/create'
    },
    showUser: () => {
      return 'meeting-links/create?intro=true'
    }
  },
  [OnlineAppointmentsSteps.ADD_APPOINTMENT_SLOTS]: {
    redirect: () => {
      return 'meeting-links?tab=availabilities'
    },
    showUser: () => {
      return 'meeting-links?intro=true&tab=availabilities'
    }
  },
  [OnlineAppointmentsSteps.ADD_DOCTOR_TO_LIST]: {
    redirect: () => {
      return 'meeting-links?tab=staffs'
    },
    showUser: () => {
      return 'meeting-links?intro=true&tab=staffs'
    }
  },
  [OnlineAppointmentsSteps.ACCEPT_APPOINTMENT_REQUEST]: {
    redirect: () => {
      return 'meeting-links'
    },
    showUser: () => {
      return 'meeting-links?intro=true'
    }
  },
  [OnlineAppointmentsSteps.PERFORM_APPOINTMENT_BASED_CONSULTATION]: {},
}

export const waitingRoomStepsFunctionMapping: Record<WaitingRoomSteps, { redirect?: () => void; showUser?: () => void }> = {
  [WaitingRoomSteps.CREATE_WAITING_ROOM]: {
    redirect: () => {
      return 'waiting-rooms/create'
    },
    showUser: () => {
      return 'waiting-rooms/create?intro=true'
    }
  },
  [WaitingRoomSteps.SETUP_OPENING_HOURS]: {
    redirect: () => {
      return 'waiting-rooms'
    },
    showUser: () => {
      return 'waiting-rooms/create?intro=true'
    }
  },
  [WaitingRoomSteps.PERFORM_WAITING_ROOM_CONSULTATION]: {
    redirect: () => {
      return 'waiting-rooms'
    },
  },
}

export const videoConfEquipmentStepsFunctionMapping: Record<VideoConfEquipmentSteps, { redirect?: () => void; showUser?: () => void }> = {
  [VideoConfEquipmentSteps.SETUP_CAMERA]: {
    redirect: () => {
      return 'configuration?section=deviceForm'
    },
  },
  [VideoConfEquipmentSteps.SETUP_MIC]: {
    redirect: () => {
      return 'configuration?section=deviceForm'
    },
  },
}
// steps mapping

export const MainToChildStepsMapping: Record<MainSteps, any[]> = {
  [MainSteps.COMPLETE_ACCOUNT_SETUP]: Object.values(AccountSetupSteps),
  [MainSteps.CONSULT_FIRST_PATIENT]: Object.values(ConsultFirstPatientSteps),
  [MainSteps.PERFORM_FIRST_TELECONSULTATION]: Object.values(FirstTeleconsultationSteps),
  [MainSteps.REQUEST_DOCTOR_EXPERTISE]: Object.values(DoctorExpertiseSteps),
  [MainSteps.ACTIVATE_ONLINE_APPOINTMENTS]: Object.values(OnlineAppointmentsSteps),
  [MainSteps.CREATE_WAITING_ROOM]: Object.values(WaitingRoomSteps),
  [MainSteps.CONFIGURE_VIDEO_CONFERENCE_EQUIPMENT]: Object.values(VideoConfEquipmentSteps),
}
export const staffTypeMapping: Record<StaffType, MainSteps[]> = {
  [StaffType.PDS]: [
    MainSteps.COMPLETE_ACCOUNT_SETUP,
    MainSteps.CONSULT_FIRST_PATIENT,
    MainSteps.PERFORM_FIRST_TELECONSULTATION,
    MainSteps.REQUEST_DOCTOR_EXPERTISE,
    MainSteps.ACTIVATE_ONLINE_APPOINTMENTS,
  ],
  [StaffType.MEDECIN]: [
    MainSteps.COMPLETE_ACCOUNT_SETUP,
    MainSteps.REQUEST_DOCTOR_EXPERTISE,
    MainSteps.CONFIGURE_VIDEO_CONFERENCE_EQUIPMENT,
    MainSteps.CREATE_WAITING_ROOM,
  ],
}
